import { gql } from "@apollo/client";

export const GET_TEMPLATE_HISTORY = gql`
    query GetTemplateHistory($processID: ID!) {
        processHistory(processID: $processID) {
            requestSysId
            processState
            createdOn
            lastUpdatedOn
        }
    }
`;
